import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.company.exitreview');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-company-exitreview',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.widget.company.exitreview/view.scss */
:host {
  display: block;
}`],
})
export class PortalLpsysadminWidgetCompanyExitreviewComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() company: any;
    @Input() category: any = 'investment';
    @Input() mode: string = 'review';

    public loading: boolean = true;
    public saving: boolean = false;
    public exitReview: any = null;
    public investmentSummary: any = { investments: [] };

    public documentItems: any[] = [
        { key: 'exit_report', label: '회수검토보고서' },
        { key: 'shareholder', label: '최신 주주명부' },
        { key: 'valuation', label: '가치평가/거래조건 자료' },
        { key: 'contract_draft', label: '매각/회수 계약서 초안' },
        { key: 'etc', label: '기타 첨부자료' },
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public isReviewMode(): boolean {
        return this.mode !== 'committee';
    }

    public isCommitteeMode(): boolean {
        return this.mode === 'committee';
    }

    public pageTitle(): string {
        return this.isCommitteeMode() ? '회수심의' : '회수검토';
    }

    public pageDescription(): string {
        if (this.isCommitteeMode()) {
            return `${this.company?.company_name || '기업'}의 회수관리위원회 일정, 자료, 위원 의견과 결과를 관리합니다.`;
        }
        return `${this.company?.company_name || '기업'}의 회수 조건, 예상 회수금액, 회수 사유와 리스크를 검토합니다.`;
    }

    public async load() {
        if (!this.company?.id) {
            this.loading = false;
            await this.service.render();
            return;
        }
        const { code, data } = await wiz.call('load', { company_id: this.company.id });
        if (code === 200) {
            this.exitReview = data.data.exit_review;
            this.investmentSummary = this.exitReview.investment_summary || { investments: [] };
            this.ensureShape();
        }
        this.loading = false;
        await this.service.render();
    }

    private ensureShape() {
        if (!this.exitReview.review_data) this.exitReview.review_data = {};
        if (!this.investmentSummary) this.investmentSummary = { investments: [], fund_options: [] };
        if (!this.investmentSummary.investments) this.investmentSummary.investments = [];
        if (!this.investmentSummary.available_investments) this.investmentSummary.available_investments = this.investmentSummary.investments || [];
        if (!this.investmentSummary.fund_options) this.investmentSummary.fund_options = [];
        if (!this.exitReview.review_data.selected_fund_id && this.investmentSummary.selected_fund_id) {
            this.exitReview.review_data.selected_fund_id = this.investmentSummary.selected_fund_id;
        }
        if (!Array.isArray(this.exitReview.review_data.selected_investment_ids)) {
            this.exitReview.review_data.selected_investment_ids = [];
        }
        if (this.investmentSummary.selected_investment_ids) {
            this.exitReview.review_data.selected_investment_ids = this.normalizeIds(this.investmentSummary.selected_investment_ids);
        } else {
            this.exitReview.review_data.selected_investment_ids = this.normalizeIds(this.exitReview.review_data.selected_investment_ids);
        }
        if (!this.exitReview.exit_committee) this.exitReview.exit_committee = { documents: {}, members: [], result: {} };
        if (!this.exitReview.exit_committee.documents) this.exitReview.exit_committee.documents = {};
        if (!this.exitReview.exit_committee.members) this.exitReview.exit_committee.members = [];
        if (!this.exitReview.exit_committee.result) this.exitReview.exit_committee.result = { decision: 'pending', memo: '' };
        for (const item of this.documentItems) this.ensureDoc(item.key, item.label);
        this.refreshInvestmentSummary();
    }

    private ensureDoc(key: string, label: string) {
        const docs = this.exitReview.exit_committee.documents;
        if (!docs[key]) docs[key] = { label, url: '', name: '', updated_at: '' };
        if (!docs[key].label) docs[key].label = label;
        if (docs[key].is_default === undefined) docs[key].is_default = true;
    }

    public doc(key: string) {
        return this.exitReview?.exit_committee?.documents?.[key] || { label: key, url: '', name: '' };
    }

    public payload() {
        this.recalc();
        return {
            status: this.exitReview.status,
            review_data: this.exitReview.review_data,
            exit_committee: this.exitReview.exit_committee,
        };
    }

    public async save(showAlert: boolean = true) {
        if (!this.exitReview || !this.company?.id) return;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('save', {
            company_id: this.company.id,
            data: JSON.stringify(this.payload())
        });
        this.saving = false;
        if (code === 200) {
            this.exitReview = data.data;
            this.investmentSummary = this.exitReview.investment_summary || { investments: [] };
            this.ensureShape();
            if (showAlert) this.service.alert.success('저장되었습니다.');
        } else {
            this.service.alert.error(data?.message || '저장에 실패했습니다.');
        }
        await this.service.render();
    }

    public async onExitFundChange() {
        const fundId = String(this.exitReview?.review_data?.selected_fund_id || '').trim();
        if (fundId) {
            this.exitReview.review_data.selected_investment_ids = this.availableInvestments()
                .filter((row: any) => String(row?.fund_id || '').trim() === fundId)
                .map((row: any) => String(row?.id || '').trim())
                .filter((id: string) => !!id);
        }
        this.refreshInvestmentSummary();
        await this.save(false);
    }

    public availableInvestments(): any[] {
        return this.investmentSummary?.available_investments || this.investmentSummary?.investments || [];
    }

    private normalizeIds(ids: any): string[] {
        if (!Array.isArray(ids)) return [];
        const seen: any = {};
        const result: string[] = [];
        for (const id of ids) {
            const key = String(id || '').trim();
            if (!key || seen[key]) continue;
            seen[key] = true;
            result.push(key);
        }
        return result;
    }

    public selectedInvestmentIds(): string[] {
        const ids = this.normalizeIds(this.exitReview?.review_data?.selected_investment_ids || []);
        if (this.exitReview?.review_data) this.exitReview.review_data.selected_investment_ids = ids;
        return ids;
    }

    public selectedInvestmentCount(): number {
        return this.selectedInvestmentIds().length;
    }

    public isInvestmentSelected(row: any): boolean {
        const id = String(row?.id || '').trim();
        return !!id && this.selectedInvestmentIds().indexOf(id) >= 0;
    }

    public toggleInvestment(row: any, event: any) {
        const id = String(row?.id || '').trim();
        if (!id) return;
        const checked = !!event?.target?.checked;
        const ids = this.selectedInvestmentIds();
        this.exitReview.review_data.selected_investment_ids = checked
            ? this.normalizeIds(ids.concat([id]))
            : ids.filter((item: string) => item !== id);
        this.syncSelectedFundFromInvestments();
        this.refreshInvestmentSummary();
        this.service.render();
    }

    public selectAllInvestments() {
        this.exitReview.review_data.selected_investment_ids = this.availableInvestments()
            .map((row: any) => String(row?.id || '').trim())
            .filter((id: string) => !!id);
        this.syncSelectedFundFromInvestments();
        this.refreshInvestmentSummary();
        this.service.render();
    }

    private syncSelectedFundFromInvestments() {
        const selectedIds = this.selectedInvestmentIds();
        const fundIds: string[] = [];
        for (const row of this.availableInvestments()) {
            const rowId = String(row?.id || '').trim();
            const fundId = String(row?.fund_id || '').trim();
            if (!rowId || selectedIds.indexOf(rowId) < 0 || !fundId || fundIds.indexOf(fundId) >= 0) continue;
            fundIds.push(fundId);
        }
        this.exitReview.review_data.selected_fund_id = fundIds.length === 1 ? fundIds[0] : '';
    }

    private refreshInvestmentSummary() {
        if (!this.exitReview?.review_data) return;
        const selectedIds = this.selectedInvestmentIds();
        const rows = this.availableInvestments().filter((row: any) => selectedIds.indexOf(String(row?.id || '').trim()) >= 0);
        let principal = 0;
        let recovered = 0;
        let investedShares = 0;
        let soldShares = 0;
        let holdingShares = 0;
        let firstInvestmentDate = '';

        for (const row of rows) {
            principal += Number(row?.principal || 0);
            recovered += Number(row?.recovered_amount || 0);
            investedShares += Number(row?.invested_shares || 0);
            soldShares += Number(row?.sold_shares || 0);
            holdingShares += Number(row?.holding_shares || 0);
            const date = String(row?.investment_date || '').trim();
            if (date && (!firstInvestmentDate || date < firstInvestmentDate)) firstInvestmentDate = date;
        }

        this.investmentSummary.investments = rows;
        this.investmentSummary.selected_investment_ids = selectedIds;
        this.investmentSummary.selected_fund_id = this.exitReview.review_data.selected_fund_id || '';
        this.investmentSummary.investment_principal = principal;
        this.investmentSummary.recovered_amount = recovered;
        this.investmentSummary.invested_shares = investedShares;
        this.investmentSummary.sold_shares = soldShares;
        this.investmentSummary.holding_shares = holdingShares;
        this.investmentSummary.first_investment_date = firstInvestmentDate;
        this.recalc();
    }

    public async uploadDoc(key: string) {
        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        const target = this.doc(key);
        const fd = new FormData();
        fd.append('upload', files[0]);
        this.saving = true;
        await this.service.render();
        try {
            const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
            target.url = url;
            target.name = files[0].name;
            target.updated_at = new Date().toISOString();
            await this.save(false);
        } catch (e) {
            this.service.alert.error('파일 업로드에 실패했습니다.');
        }
        this.saving = false;
        await this.service.render();
    }

    public async sendNotice() {
        const confirmed = await this.service.alert.show({
            title: '회수심의 알림 발송',
            message: '등록된 위원 이메일로 일정과 개별 의견 입력 링크를 발송하시겠습니까?',
            cancel: '취소',
            action: '발송',
            actionBtn: 'info',
            status: 'info'
        });
        if (!confirmed) return;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('send_notice', {
            company_id: this.company.id,
            data: JSON.stringify(this.payload())
        });
        this.saving = false;
        if (code === 200) {
            this.exitReview = data.data;
            this.investmentSummary = this.exitReview.investment_summary || { investments: [] };
            this.ensureShape();
            this.service.alert.success(`${data.data.sent || 0}명에게 발송했습니다.`);
        } else {
            this.service.alert.error(data?.message || '알림 발송에 실패했습니다.');
        }
        await this.service.render();
    }

    public addMember() {
        this.exitReview.exit_committee.members.push({
            name: '',
            email: '',
            role: '',
            decision: 'pending',
            opinion: '',
            responded_at: '',
        });
        this.service.render();
    }

    public removeMember(index: number) {
        this.exitReview.exit_committee.members.splice(index, 1);
        this.service.render();
    }

    public recalc() {
        const d = this.exitReview?.review_data;
        if (!d) return;
        const principal = Number(this.investmentSummary?.investment_principal || d.investment_principal || 0);
        const recovered = Number(this.investmentSummary?.recovered_amount || d.recovered_amount || 0);
        const holding = Number(this.investmentSummary?.holding_shares || d.holding_shares || 0);
        const sellShares = Math.min(Math.max(Number(d.sell_shares || 0), 0), holding || Number(d.sell_shares || 0));
        const sellPrice = Math.max(Number(d.sell_price_per_share || 0), 0);
        const saleAmount = sellShares * sellPrice;
        const remaining = Math.max(holding - sellShares, 0);
        const remainingValue = remaining * sellPrice;
        const multiple = principal > 0 ? (recovered + saleAmount + remainingValue) / principal : 0;
        d.investment_principal = principal;
        d.recovered_amount = recovered;
        d.holding_shares = holding;
        d.sell_shares = sellShares;
        d.sale_amount = saleAmount;
        d.remaining_after_sale = remaining;
        d.remaining_expected_value = remainingValue;
        d.expected_multiple = multiple ? Math.round(multiple * 10000) / 10000 : 0;
        d.expected_irr = this.calcIrr(d.expected_multiple, this.investmentSummary?.first_investment_date, d.expected_exit_date);
    }

    public calcIrr(multiple: number, start: string, end: string): number {
        if (!multiple || !start || !end) return 0;
        const startDate = new Date(start);
        const endDate = new Date(end);
        if (!startDate.getTime() || !endDate.getTime() || endDate <= startDate) return 0;
        const years = (endDate.getTime() - startDate.getTime()) / (365.25 * 24 * 60 * 60 * 1000);
        if (years <= 0) return 0;
        return Math.round((Math.pow(multiple, 1 / years) - 1) * 10000) / 100;
    }

    public statusLabel(status: string): string {
        const map: any = { draft: '작성중', reviewing: '검토중', approved: '승인', rejected: '부결', completed: '회수완료' };
        return map[status] || status || '작성중';
    }

    public decisionLabel(value: string): string {
        const map: any = { pending: '미정', approve: '승인', reject: '부결', abstain: '기권' };
        return map[value] || value || '미정';
    }

    public formatAmount(value: any): string {
        const amount = Number(value || 0);
        if (!amount) return '0원';
        if (Math.abs(amount) >= 100000000) return (amount / 100000000).toFixed(1) + '억원';
        return amount.toLocaleString() + '원';
    }

    public formatShares(value: any): string {
        const count = Number(value || 0);
        if (!count) return '-';
        return Math.round(count).toLocaleString() + '주';
    }

    public formatMultiple(value: any): string {
        const num = Number(value || 0);
        if (!num) return '-';
        return (Math.round(num * 100) / 100).toLocaleString() + 'x';
    }

    public formatPercent(value: any): string {
        const num = Number(value || 0);
        if (!num) return '-';
        return num.toFixed(2).replace(/0+$/, '').replace(/\.$/, '') + '%';
    }

}

export default PortalLpsysadminWidgetCompanyExitreviewComponent;